export const storeLocally = (key, value) => {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error("Error storing data in localStorage", error);
  }
};

export const getFromLocal = (key) => {
  try {
    const serializedValue = localStorage.getItem(key);
    if (!serializedValue) return undefined;
    return JSON.parse(serializedValue);
  } catch (error) {
    console.error("Error retrieving data from localStorage", error);
    return undefined;
  }
};

export const deleteLocalEntry = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing data from localStorage", error);
  }
};
